import { type ButtonHTMLAttributes } from 'react'
import { cn } from '#app/utils/misc.tsx'

/**
 * Pills. One primary per screen, and it says what happens ("Zet kapper op
 * morgen om 10:00"). `disabledHint` is the "uitgeschakeld zegt wat er nog
 * mist" state: chip ground, muted text, still a button — its label is the
 * hint ("Schrijf eerst wat er moet gebeuren") and its click may explain.
 */
export type OyButtonVariant =
	'primary' | 'secondary' | 'quiet' | 'ghost' | 'disabledHint'

const variantClass: Record<OyButtonVariant, string> = {
	primary: 'oy-btn-primary',
	secondary: 'oy-btn-secondary',
	quiet: 'oy-btn-quiet',
	ghost: 'oy-btn-ghost',
	disabledHint: 'oy-btn-hint',
}

export function OyButton({
	variant = 'primary',
	size,
	className,
	type = 'button',
	children,
	...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: OyButtonVariant
	/** 48 / 44 / 40px — the variant's own height when omitted */
	size?: 'lg' | 'md' | 'sm'
}) {
	return (
		<button
			type={type}
			aria-disabled={variant === 'disabledHint' ? true : undefined}
			className={cn(
				'oy-btn',
				variantClass[variant],
				size && `size-${size}`,
				className,
			)}
			{...props}
		>
			{children}
		</button>
	)
}
